import { paperClasses } from '@mui/material';
import { t } from 'i18next';

import Dialog from '~components/Dialog/Dialog';
import DialogActions from '~components/Dialog/DialogActions';
import DialogContent from '~components/Dialog/DialogContent';
import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';
import { Order } from '~hooks/useOrders/models';

import CopyVendorAssignmentsForm from './CopyVendorAssignmentsForm';

interface CopyVendorAssignmentsDialogProps {
  companyId: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onSelectedOrderChange: (order: Order) => void;
  orderId?: string;
}

export default function CopyVendorAssignmentsDialog({
  companyId,
  isOpen,
  onClose,
  onConfirm,
  onSelectedOrderChange,
  orderId,
}: CopyVendorAssignmentsDialogProps) {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="lg"
      sx={{ [`& .${paperClasses.root}`]: { height: '400px' } }}
    >
      <DialogContent
        sx={{
          '& > div': {
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100%',
            p: 0,
          },
        }}
      >
        <CopyVendorAssignmentsForm
          companyId={companyId}
          onSelectedOrderChange={onSelectedOrderChange}
          orderId={orderId}
        />
      </DialogContent>

      <DialogActions>
        <SmallButton onClick={onClose} color="secondary" variant="outlined">
          {t('actions.cancel')}
        </SmallButton>

        <SmallButton disabled={!orderId} onClick={onConfirm} color="primary">
          {t('actions.copy_to')}
        </SmallButton>
      </DialogActions>
    </Dialog>
  );
}
